'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setLooping;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setLooping(playerId, options) {
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant2.default)((options.startTimeMs || options.startTimeMs === 0) && typeof options.startTimeMs === 'number', 'Redux Action:setLooping: startTimeMs must be a number');

    (0, _invariant2.default)(options.endTimeMs && typeof options.endTimeMs === 'number', 'Redux Action:setLooping: endTimeMs must be a number');

    (0, _invariant2.default)(options.endTimeMs > options.startTimeMs, 'Redux Action:setLooping: The startTimeMs (' + options.startTimeMs + ') should be before\n      the endTimeMs (' + options.endTimeMs + ')');
  }

  return {
    type: _constants.SET_LOOPING,
    options: options,
    playerId: playerId
  };
}
module.exports = exports['default'];